<!-- =========================================================================================
  File Name: activityLog.vue
  Description: Record Activity Log
========================================================================================== -->

<template>
  <div id="record-activity">

    <vx-card title="活动日志">
      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <flat-pickr v-model="startTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <template slot="prepend">
            <flat-pickr v-model="endTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <vs-input class="w-48" v-model="uid" placeholder="UID / 用户名" />
          <template slot="append">
            <vs-select class="w-48" v-model="typeVal">
              <vs-select-item :key="index" :value="item.shortname" :text="item.name" v-for="(item, index) in typeList" />
            </vs-select>
          </template>
          <template slot="append">
            <vs-select class="w-48" v-model="status">
              <vs-select-item :key="index" :value="index - 1" :text="item" v-for="(item, index) in ['全部状态', '未发放', '已发放']" />
            </vs-select>
          </template>
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>
      <vs-table stripe :data="list" noDataText="暂无日志记录">
        <template slot="thead">
          <vs-th width="80">UID</vs-th>
          <vs-th width="100">用户名</vs-th>
          <vs-th width="100">类型</vs-th>
          <vs-th width="120">金额 (元)</vs-th>
          <vs-th width="120">下注额 (元)</vs-th>
          <vs-th width="120">盈亏 (元)</vs-th>
          <vs-th width="120">比例 (%)</vs-th>
          <vs-th width="120">状态</vs-th>
          <vs-th width="160">时间</vs-th>
          <vs-th width="100">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list">
            <vs-td :data="item.receiveUid">{{item.receiveUid}}</vs-td>
            <vs-td :data="item.receiveUser">{{item.receiveUser.username}}</vs-td>
            <vs-td :data="item.shortname">{{typeList[item.shortname].name}}</vs-td>
            <vs-td :data="item.totalCount">{{item.totalCount}}</vs-td>
            <vs-td :data="item.bet">{{item.bet}}</vs-td>
            <vs-td :data="item.earn">{{item.earn}}</vs-td>
            <vs-td :data="item.rate">{{item.rate}}</vs-td>
            <vs-td :data="item.status">{{item.status == 1 ? '已发放' : '未发放'}}</vs-td>
            <vs-td :data="item.date">{{item.date}}</vs-td>
            <vs-td>
              <vs-button color="success" type="filled" size="small" @click="send" :data-index="index" v-if="item.status == 0">发放</vs-button>
              <vs-button color="danger" type="filled" size="small" @click="del" :data-index="index">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'

export default {
  data() {
    return {
      page: 1,
      totalPage: 1,
      list: [],
      startTime: '',
      endTime: '',
      shortname: '',
      uid: '',
      typeList: { default: { shortname: '', name: '类型' } },
      typeVal: 0,
      status: -1,
      flatPickrConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        locale: flatPickrZh
      }
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  methods: {
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.page = this.page
      postdata.start = this.startTime
      postdata.end = this.endTime
      postdata.uid = this.uid
      postdata.status = this.status
      postdata.type = this.typeVal != '' ? this.typeList[this.typeVal].shortname : ''
      this.$utils.post('record-activityLogList', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    },
    del(e) {
      const index = e.currentTarget.dataset.index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该条记录吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          const postdata = {}
          postdata.authKey = localStorage.getItem('authKey')
          postdata.id = this.list[index].id
          this.$utils.post('record-activityLogDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.load()
          })
        }
      })
    },
    send(e) {
      const index = e.currentTarget.dataset.index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认发放吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          const postdata = {}
          postdata.authKey = localStorage.getItem('authKey')
          postdata.id = this.list[index].id
          this.$utils.post('record-activityLogSend', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.load()
          })
        }
      })
    },
    search() {
      this.page = 1
      this.load()
    }
  },
  mounted () {
    // 初始化时间
    const myDate = new Date()
    this.endTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)
    myDate.setTime(myDate.getTime() - 86400000 * 1)
    this.startTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)

    // 状态
    this.$utils.post('setting-activityList', { authKey: localStorage.getItem('authKey') }).then(res => {
      for (const i in res) {
        this.typeList[res[i].shortname] = { shortname: res[i].shortname, name: res[i].title }
      }
    })

    this.load()
  }
}
</script>
